export default "__VITE_ASSET__423dec1c__"